export const CANT_FIND_BANK_MODAL_ID = 'cant-find-bank-modal';
